import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { UiModule } from '@app/ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { TogglePublishingBannerCollapsed } from '../../states/publishing.actions';
import { PublishingState } from '../../states/publishing.state';
import { PaidPublicationModalComponent } from '../paid-publication-modal/paid-publication-modal.component';

@Component({
  selector: 'rk-paid-publishing-banner',
  imports: [TranslatePipe, UiModule, FontAwesomeModule, AsyncPipe],
  templateUrl: './paid-publishing-banner.component.html',
  styleUrl: './paid-publishing-banner.component.scss',
})
export class PaidPublishingBannerComponent {
  private readonly dialog = inject(MatDialog);
  private readonly store = inject(Store);
  isCollapsed$: Observable<boolean> = this.store.select(
    PublishingState.publishingBannerCollapsed,
  );

  onCtaClick() {
    this.dialog.open(PaidPublicationModalComponent, {});

    // tracking
    this.store.dispatch(
      new SetEventProperties({
        name: `ButtonPaidPublishing`,
        component: 'Publishing',
      }),
    );
    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  toggleVisibility() {
    this.store.dispatch(new TogglePublishingBannerCollapsed());
  }
}
